import React from 'react';
import { useParams } from 'react-router-dom';
import News from './News/News';
import Contact from './Contact/Contact';
import Product from './Product/Product';
import PartnerShip from './PartnerShip/PartnerShip';

const BoardList = () => {
  const { category } = useParams();

  const renderBoardContent = () => {
    switch (category) {
      case 'product':
        return <Product />;
      case 'partnership':
        return <PartnerShip />;
      case 'news':
        return <News />;
      case 'contact_us':
        return <Contact />;
      default:
        return <div>게시판을 찾을 수 없습니다.</div>;
    }
  };

  return <>{renderBoardContent()}</>;
};

export default BoardList;

{
  /* <div className={`board-main-wrap ${category}`}>
      <div className="board-title-wrap"></div>
      {renderBoardContent()}
    </div> */
}
